import React, { useContext, useEffect } from "react";
import { useViewport } from "@bookingcom/bui-react";
import { RemoteFooter } from "../../remote/index.js";
import { STICKY_FOOTER_SPACER_ID } from "../../../constants.js";
import scrollToTop from "../../../utils/scrollToTop.js";
import styles from "./AppShell.desktop.module.css";
import { mcn } from "../../../utils/mergeClassnames.js";
import useIsPostBookingRoute from "../../../hooks/useIsPostBookingRoute.js";
import useFlyAnywhereRoute from "../FlyAnywhere/hooks/useFlyAnywhereRoute.js";
import { OutletContext } from "./Outlet/index.js";
const AppShell = (props) => {
    const { header, children, noMainWrapper } = props;
    const { isSmall } = useViewport();
    const isPostBooking = useIsPostBookingRoute();
    const isFlyAnywhereRoute = useFlyAnywhereRoute();
    const { sheetContainer } = useContext(OutletContext);
    useEffect(scrollToTop, []);
    const content = (React.createElement("div", { className: mcn(styles.content, props.className, !isPostBooking && isSmall && styles.contentSmall), style: { ...props.style } }, children));
    return (React.createElement("div", { className: mcn(styles.root, isFlyAnywhereRoute && styles.flyAnywhere) },
        !!header && React.createElement("div", { id: "app-header" }, header),
        noMainWrapper ? (content) : (React.createElement("main", { role: "main", id: "basiclayout", key: "app-shell" }, content)),
        React.createElement("div", { id: STICKY_FOOTER_SPACER_ID, "aria-hidden": true }),
        React.createElement(RemoteFooter, null),
        sheetContainer));
};
export default AppShell;
